import api from '../api';
import Sala from '../model/ProcessoSala';

interface ApiError {
    response?: {
        data: {
            message: string;
        };
        status: number;
    };
}

export class SalaViewModel {
    static async criarSala(dados: Sala, processoId: string): Promise<Sala> {
        try {
            const salaPost = { link: dados.salaUrl };
            const response = await api.post(`/processos/${processoId}/salas/espera`, salaPost);
            return {
                id: response.data.id,
                salaUrl: response.data.link,
            };
        } catch (error: unknown) {
            if (error instanceof Error) {
                const apiError = error as ApiError;
                if (apiError.response && apiError.response.status === 400) {
                    throw new Error(apiError.response.data.message || 'Erro ao criar sala');
                }
                throw new Error(error.message);
            }
            throw new Error('Erro desconhecido ao criar sala');
        }
    }

    static async patchLinkSala(salaId: string, novoLink: string): Promise<void> {
        try {
            await api.patch(`/processos/salas/${salaId}`, { link: novoLink });
        } catch (error: unknown) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw new Error('Erro desconhecido ao atualizar link da sala');
        }
    }
    static async postLinkSala(processoId: string, novoLink: string): Promise<void> {
        try {
            await api.patch(`/processos/${processoId}/salas`, { link: novoLink });
        } catch (error: unknown) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw new Error('Erro desconhecido ao atualizar link da sala');
        }
    }

    static async obterSalaPorId(processoId: string): Promise<Sala[]> {
        try {
            const response = await api.get(`/processos/${processoId}/salas`);
            const salas = response.data;

            const sala: Sala | null = {
                id: salas.salaEspera.id,
                salaUrl: salas.salaEspera.link,
            }

            return sala ? [sala] : [];
        } catch (error: unknown) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw new Error('Erro desconhecido ao obter salas');
        }
    }

}
